import { ADD_DEPOSIT_LINE_REQUEST, ADD_DEPOSIT_LINE_SUCCESS, ADD_DEPOSIT_LINE_ERROR, GET_ONE_DEPOSIT_LINE_ERROR, GET_ONE_DEPOSIT_LINE_SUCCESS, GET_ONE_DEPOSIT_LINE_REQUEST, GET_DEPOSIT_DETAIL_REQUEST, GET_DEPOSIT_DETAIL_SUCCESS, GET_DEPOSIT_DETAIL_ERROR, UPDATE_DEPOSIT_LINE_REQUEST, UPDATE_DEPOSIT_LINE_SUCCESS, UPDATE_DEPOSIT_LINE_ERROR, DELETE_DEPOSIT_LINE_REQUEST, DELETE_DEPOSIT_LINE_SUCCESS, DELETE_DEPOSIT_LINE_ERROR } from "./types";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const addDepositLine = (token, data) => dispatch => {
  
  
  
  

  dispatch({ type: ADD_DEPOSIT_LINE_REQUEST });

  return axios({
    method: "POST",
    url: `${BASEURL}create/payBankOtherDepositLines`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { data },
  })
    .then(response => {
      return dispatch({
        type: ADD_DEPOSIT_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      return dispatch({
        type: ADD_DEPOSIT_LINE_ERROR,
        payload: error.response,
      });
    });
};

export const getOneDepositLine = (token, customerRefundId) => dispatch => {

  dispatch({ type: GET_ONE_DEPOSIT_LINE_REQUEST });
  return axios({
    method: "GET",
    url: `${BASEURL}getOne/payBankOtherDepositLines/${customerRefundId}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
  })
    .then(response => {
      return dispatch({
        type: GET_ONE_DEPOSIT_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      return dispatch({
        type: GET_ONE_DEPOSIT_LINE_ERROR,
        payload: error.response,
      });
    });
};

export const getDepositDetails = (token, customerID) => dispatch => {
  dispatch({ type: GET_DEPOSIT_DETAIL_REQUEST });
  let newData = {
    customer_id: customerID,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/CustomerNoteForRefund`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then(response => {
      return dispatch({
        type: GET_DEPOSIT_DETAIL_SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      return dispatch({
        type: GET_DEPOSIT_DETAIL_ERROR,
        payload: error.response,
      });
    });
};

export const updateDepositLine = (token, data, id) => dispatch => {

  
  
  
  
  
  
  
  
  dispatch({ type: UPDATE_DEPOSIT_LINE_REQUEST });
  return axios({
    method: "PUT",
    url: `${BASEURL}update/payBankOtherDepositLines/${id}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { data },
  })
    .then(response => {
      return dispatch({
        type: UPDATE_DEPOSIT_LINE_SUCCESS,
        payload: response?.data,
      });
    })
    .catch(error => {
      return dispatch({
        type: UPDATE_DEPOSIT_LINE_ERROR,
        payload: error.response,
      });
    });
};

export const deleteDepositLine = (token, idd, data) => dispatch => {

  data.map((val) => {
    delete val.account_id;
    delete val.account_name;
    delete val.amount;
    delete val.created_by;
    delete val.created_date;
    
    delete val.entity_id;
    delete val.entity_type;
    delete val.instrument_no;
    delete val.is_deleted;
    delete val.last_updated_by;
    delete val.last_updated_date;
    delete val.memo;
    delete val.payment_method_id;
    delete val.payment_method_name;
  })

  dispatch({ type: DELETE_DEPOSIT_LINE_REQUEST });
  return axios({
    method: "DELETE",
    url: `${BASEURL}delete/payBankOtherDepositLines/${idd}`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: { data: data }
  })
    .then(response => {
      return dispatch({
        type: DELETE_DEPOSIT_LINE_SUCCESS,
        payload: response.data,
      });
    })
    .catch(error => {
      return dispatch({
        type: DELETE_DEPOSIT_LINE_ERROR,
        payload: error.response,
      });
    });
};
